import { useCallback, useEffect, useState, useRef } from "react";

const MultiRangeSlider = ({ min, max, onChange, reset }) => {
  const [minVal, setMinVal] = useState(min);
  const [maxVal, setMaxVal] = useState(max);
  const [changeFilter, setChangeFilter] = useState(false);
  const minValRef = useRef(null);
  const maxValRef = useRef(null);
  const range = useRef(null);

  const midpoint = (min + max) / 2;
  const minThumbOnTop = minVal > midpoint;

  useEffect(() => {
    if (reset) {
      setMinVal(1.8);
      setMaxVal(2.5);
    }
  }, [reset]);

  const getPercent = useCallback(
    (value) => Math.round(((value - min) / (max - min)) * 100),
    [min, max],
  );

  useEffect(() => {
    if (!range.current) {
      return;
    }

    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxVal);
    range.current.style.left = `${minPercent}%`;
    range.current.style.width = `${maxPercent - minPercent}%`;
  }, [minVal, maxVal, getPercent]);

  useEffect(() => {
    if (changeFilter) {
      onChange({ min: minVal, max: maxVal });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minVal, maxVal]);

  return (
    <div className="range-slider">
      <div className="slider__left-value">${minVal.toFixed(2)}</div>
      <div className="slider">
        <div className="slider__track" />
        <div ref={range} className="slider__range" />
        <input
          type="range"
          min={min}
          max={max}
          step="0.1"
          value={minVal}
          ref={minValRef}
          onChange={(event) => {
            setChangeFilter(true);
            const value = Math.min(+event.target.value, maxVal - 0.2);
            setMinVal(value);
            event.target.value = value.toString();
          }}
          className={`thumb ${
            minThumbOnTop ? "thumb--zindex-5" : "thumb--zindex-3"
          }`}
        />
        <input
          type="range"
          min={min}
          max={max}
          step="0.1"
          value={maxVal}
          ref={maxValRef}
          onChange={(event) => {
            setChangeFilter(true);
            const value = Math.max(+event.target.value, minVal + 0.2);
            setMaxVal(value);
            event.target.value = value.toString();
          }}
          className={`thumb ${
            minThumbOnTop ? "thumb--zindex-4" : "thumb--zindex-5"
          }`}
        />
      </div>
      <div className="slider__right-value">${maxVal.toFixed(2)}</div>
    </div>
  );
};

export default MultiRangeSlider;
